import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

const ComponentPieChart = (props) => {
  ChartJS.register(ArcElement, Tooltip, Legend);

  const { labels, datasets, titleGraphe } = props;

  const getRandomRgb = () => {
    var num = Math.round(0xffffff * Math.random());
    var r = num >> 16;
    var g = (num >> 8) & 255;
    var b = num & 255;
    return "rgb(" + r + ", " + g + ", " + b + ",0.7)";
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: titleGraphe,
      },
    },
  };

  const data = {
    labels: labels,
    datasets: [
      {
        data: datasets,
        backgroundColor: [
          getRandomRgb(),
          getRandomRgb(),
          getRandomRgb(),
          getRandomRgb(),
          getRandomRgb(),
          getRandomRgb(),
        ],
        borderColor: ["rgba(0, 0, 0, 0.2)"],
        borderWidth: 1,
      },
    ],
  };

  return <Pie options={options} data={data} />;
};

export default ComponentPieChart;
